import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import { RESET_AMWELL_ACTIVITY } from '../actions';
import { Allergy } from './types';
import * as actions from './actions';

export type AllergiesState = Readonly<{
  data: Allergy[];
  loading: {
    data: boolean;
    action: boolean;
  };
  errors: {
    data: Nullable<Error>;
    action: Nullable<Error>;
  };
}>;

export const allergiesInitialState: AllergiesState = {
  data: [],
  loading: { data: false, action: false },
  errors: { data: null, action: null }
};

export const allergiesReducer = createReducer(allergiesInitialState, {
  [actions.GET_ALLERGIES]: state => {
    state.loading.data = true;
    state.errors.data = null;
  },
  [actions.GET_ALLERGIES_FAIL]: (state, action) => {
    state.errors.data = action.error;
    state.loading.data = false;
  },
  [actions.GET_ALLERGIES_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.data = false;
  },
  [actions.UPDATE_ALLERGIES]: state => {
    state.errors.action = null;
    state.loading.action = true;
  },
  [actions.UPDATE_ALLERGIES_FAIL]: (state, action) => {
    state.errors.action = action.error;
    state.loading.action = false;
  },
  [actions.UPDATE_ALLERGIES_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.errors.action = null;
    state.loading.action = false;
  },
  [RESET_AMWELL_ACTIVITY]: () => allergiesInitialState
});
